import DeliveryModalSection from './DeliveryModalSection';

export default DeliveryModalSection;
